import { createContext } from 'react';

const GithubContext = createContext();

export default GithubContext;
